import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import ImageModal from '../../../components/ImageModal';

const SideLiteOptionsEticom = ({ value, onChange, label = 'Option * :', disabled = false, showPics = false, }) => {
    const defaultColor = {
        value: value?.value || '#F8F8FF',
        label: value?.label || 'Clear',
      };
   
     const [selectedSideLiteOptionsEticom, setSelectedSideLiteOptionsEticom] = useState(defaultColor);
     const [showModal, setShowModal] = useState(false);

 
    const handleSideLiteOptionsEticomChange = (e) => {
        const newValue = e.target.value;
        const selectedText = e.target.options[e.target.selectedIndex].text;
    
        const newOption = { value: newValue, label: selectedText };
        setSelectedSideLiteOptionsEticom(newOption);
        onChange(newOption);
    };
 
    // 🔥 Trigger initial onChange once when mounted
    useEffect(() => {
        onChange(defaultColor);
    }, []); // empty deps = only once on mount
    

//   Hex: #F8F8FF (Ghost White) or #FFFFFF (White).
 //   Hex: #DCDCDC (Gainsboro) or #C0C0C0 (Silver).
 //   Hex: #E0E0E0 (Light Gray) or #B0C4DE (Light Steel Blue).
    return (
        <div className="a-container">
            <label htmlFor="SideLiteOptionsEticom" disabled={disabled}>
                {label}
                {showPics && (
                    <span
                        onClick={() => setShowModal(true)}
                        style={{
                            display: 'inline-block',
                            marginLeft: '6px',
                            width: '16px',
                            height: '16px',
                            borderRadius: '50%',
                            backgroundColor: '#007bff',
                            color: '#fff',
                            textAlign: 'center',
                            lineHeight: '16px',
                            fontSize: '12px',
                            cursor: 'pointer',
                            userSelect: 'none'
                        }}
                        title="Click to view image"
                    >
                        i
                    </span>
                )}
            </label>
            <select
                disabled={disabled}
                id="SideLiteOptionsEticom"
                value={selectedSideLiteOptionsEticom.value}
                onChange={handleSideLiteOptionsEticomChange}
            >   
                <option value="#F8F8FF">
                {selectedSideLiteOptionsEticom.value === '#F8F8FF' ? 'Clear ✔' : 'Clear'}
                </option>
                <option value="#DCDCDC">
                {selectedSideLiteOptionsEticom.value === '#DCDCDC' ? 'Sandblasted ✔' : 'Sandblasted'}
                </option>
                <option value="#E0E0E0">
                {selectedSideLiteOptionsEticom.value === '#E0E0E0' ? 'Delta ✔' : 'Delta'}
                </option>
            </select>
            <ImageModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                folder="images/textures"
                imageName={selectedSideLiteOptionsEticom.label} // ✅ Now works!
                //width={400}
                //height={400}
            />
        </div>
    );
};

export default SideLiteOptionsEticom;
